import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import { MarkdownContent } from '@backstage/core-components';

const content = `
## Mailculer Documentation

Welcome to the Mailculer developer portal.

- [Open the Mailculer system docs](/docs/default/system/mailculer)
- [Open the catalog](/catalog)
- [Open the service list](/catalog?filters[kind]=component&filters[system]=mailculer)

### Key documentation areas

- System overview and architecture
- Service details and API docs
- Deployment and operational runbooks
- Local development and migrations

### Download

- [Download PDF version](/api/techdocs/static/docs/default/system/mailculer/pdf/mailculer-documentation.pdf)
`;

const mailculerDocsWidget = HomePageWidgetBlueprint.make({
  name: 'mailculer-docs',
  params: {
    name: 'MailculerDocs',
    title: 'Mailculer Docs',
    description: 'Mailculer system documentation landing page',
    components: async () => ({
      Content: () => <MarkdownContent content={content} />,
    }),
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [mailculerDocsWidget],
});
